module.exports = __webpack_public_path__ + "img/tree-09-c-leaves.68bea74b.png";